// File: WorkWithUsSection.jsx

import React from "react";
import { useNavigate } from "react-router-dom";
import "./WorkWithUsSection.css";

const pathways = [
  {
    label: "FOR AUTHORS",
    title: "Build a book and leadership platform.",
    button: "Publish with Us",
    icon: "✦",
    link: "/contact-us"
  },
  {
    label: "FOR BRANDS",
    title: "Build content and media that scale.",
    button: "Build IP",
    icon: "⬡",
    link: "/contact-us"
  },
  {
    label: "FOR INSTITUTIONS",
    title: "Build structured leadership systems.",
    button: "Partner with Us",
    icon: "▣",
    link: "/contact-us"
  },
];

const WorkWithUsSection = () => {
  const navigate = useNavigate();

  return (
    <section className="work-section">

      {/* DARK OVERLAY */}
      <div className="work-overlay"></div>

      <div className="work-container">

        <h2 className="work-title">Ways to Work with Ample House </h2>

        <div className="work-grid">
          {pathways.map((item, index) => (
            <div className="work-card" key={index}>

              <div className="work-icon-wrapper">
                <span className="work-icon">{item.icon}</span>
              </div>

              <span className="work-label">{item.label}</span>

              <h3 className="work-card-title">{item.title}</h3>

              <button
                className="work-btn"
                onClick={() => navigate(item.link)}
              >
                {item.button} →
              </button>

            </div>
          ))}
        </div>

      </div>

    </section>
  );
};

export default WorkWithUsSection;